import React from "react";

interface Column {
  name: string;
  title: string;
  isSortable: boolean;
}

interface Props {
  columnNames?: string[];
  columns?: Column[];
  children: React.ReactNode;
  onSortingChange?: (columnName: string, sortOrder: "asc" | "desc") => void;
  sortedBy?: string | null;
  ascending?: boolean | null;
  maxHeight?: string;
  stickyHeader?: boolean;
}

export default function Table({
  columnNames,
  children,
  columns,
  onSortingChange,
  sortedBy,
  ascending,
  maxHeight,
  stickyHeader,
}: Props) {
  const handleSortableColumnClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    column: Column,
  ) => {
    if (column.isSortable && onSortingChange) {
      const isAscending: boolean = !(
        event.target as Element
      ).classList.contains("sorting_asc");

      const otherColumns = document.body.querySelectorAll("th");

      otherColumns.forEach((element) => {
        if (
          element.classList.contains("sorting_asc") ||
          element.classList.contains("sorting_desc")
        ) {
          element.classList.add("sorting");
        }

        (element as Element).classList.remove("sorting_asc");
        (element as Element).classList.remove("sorting_desc");
        (element as Element).classList.add("sort");
      });

      (event.target as Element).classList.add(
        isAscending ? "sorting_asc" : "sorting_desc",
      );

      onSortingChange(column.name, isAscending ? "asc" : "desc");
    }
  };

  return (
    <div
      className="table-responsive"
      style={{ maxHeight, overflowY: maxHeight ? "auto" : undefined }}
    >
      <table className="table align-middle table-nowrap table-striped table-hover ">
        <thead
          className={`table-light ${stickyHeader ? "sticky-top top-0" : ""}`}
          style={{ zIndex: stickyHeader ? 2 : undefined }}
        >
          <tr>
            {columnNames &&
              columnNames.map((col) => (
                <th key={col} scope="col">
                  {col}
                </th>
              ))}
            {columns &&
              columns.map((col) => (
                <th
                  scope="col"
                  key={col.name}
                  onClick={(e) => handleSortableColumnClick(e, col)}
                  className={`${
                    col.isSortable
                      ? sortedBy === col.name
                        ? ascending
                          ? "sorting_asc"
                          : "sorting_desc"
                        : "sort"
                      : "not-sorting"
                  } `}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div style={{ cursor: "pointer" }}>{col.title}</div>
                    <button className="table-sort"></button>
                  </div>
                </th>
              ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
